<template>
  <div>
    <div class="login_con" v-if="type=='all'">
      <ul class="tabs">
        <li class="tab1_1 lr10" @click="switchTo('1')">
          <a name=".tab1_3" :class="{current:currentTab.index=='1'}">手机找回</a>
        </li>
        <li class="tab1_1 lrr10" @click="switchTo('2')">
          <a name=".tab1_4" :class="{current:currentTab.index=='2'}">邮箱找回</a>
        </li>
      </ul>
      <div class="tab_content">
        <!--手机方式找回密码-->
        <form class="tab1_4 l_left" v-show="currentTab.index == '1'" @submit.prevent="validateForm('form1')" data-vv-scope="form1" novalidate>
          <p><input v-validate="'required|phone'" v-model="form1.phone" name="phone" type="text" placeholder="手机号" class="put_tel input_two" id="yzmPhone"/></p>
          <i class="spa spa2">{{ errors.first('form1.phone') }}</i>
          <p class="mt20">
            <input name="code" type="text" class="w235 put_txt input_two" placeholder="验证码" id="yzmNum" v-validate="'required'" v-model="form1.code" />
            <get-auth-code @retrieving="getCode" @input-error="popup" :phone="form1.phone"></get-auth-code>
            <!--input id="btnSendCode" class="sendcode code" type="button" value="获取验证码" @click="sendMessage()" /-->
            <i class="spa5">{{ errors.first('form1.code') }}</i>
          </p>
          <p class="wrap w264 mt50">
            <input name="" type="submit" class="login_btn login_b input_two" value="下一步" id="sub2"/>
          </p>
        </form>
        <!--/手机方式找回密码-->
        <!--邮箱方式找回密码-->
        <form class="tab1_3 l_left" v-show="currentTab.index == '2'" @submit.prevent="validateForm('form2')" data-vv-scope="form2" novalidate>
          <p>
            <input v-validate="'required|phone'" v-model="form2.phone" name="phone" type="text" placeholder="邮箱" class="put_tel input_one" id="userphone" />
          </p>
          <i class="spa spa2">{{ errors.first('form2.phone') }}</i>
          <p class="wrap w264 mt50">
            <input name="" type="submit" class="login_btn login_b input_one" value="下一步" id="sub" />
          </p>
        </form>
        <!--/邮箱方式找回密码-->
      </div>
    </div>
    <div class="login_con" v-if="type=='phone'" style="min-height: 220px;">
      <div class="l_tit">忘记密码</div>
      <div class="reg_con">
        <p><input name="" type="text"  class="w365 put_txt input_three" id="registerThree"  placeholder="手机号" v-model="form1.phone"/></p>
        <i style="display:none;" class="spa8">请输入正确手机号</i>
        <p>
          <input name="" type="text"  class="w235 put_txt input_three" id="registerFour" placeholder="验证码" v-model="form1.code"/>
          <get-auth-code @retrieving="getCode" @input-error="popup" :phone="form1.phone"></get-auth-code>
        </p>
        <i style="display:none;" class="spa9">验证码错误</i>
        <p><input name="" type="password"  class="w365 put_txt input_three" placeholder="设置新密码" v-model="form1.password"/></p>
        <p class="wrap w264 mt30">
          <input @click="toLastStep" value="返回" type="button" class="login_btn" style="width: 128px; margin-right: 2px;" /><!--
        --><input v-debounce-click @click="next" name="" type="button" class="login_btn" value="确认" style="width: 128px;" />
        </p>
      </div>
    </div>
  </div>
</template>
<script>
  import utils from '@/utils'
import getAuthCode from '../common/getAuthCode.vue'
import '@/utils/validator.js'
export default {
  name: 'find-pwd',
  components: { getAuthCode },
  mounted () {
  },
  data () {
    return {
      form1: {}, // 普通登录
      form2: {}, // 验证码登录 (注册)
      currentTab: {
        index: '1',
        isActive: true
      }
    }
  },
  computed: {
    tabClass () {
      return {
        current: this.currentTab.isActive === true
      }
    }
  },
  methods: {
    popup (msg) {
      this.$toasted.show(msg)
    },
    switchTo (index) {
      this.currentTab.index = index
      this.currentTab.isActive = !this.currentTab.isActive
    },
    getCode () {
      this.$emit('ready-to-get-code', this.form1.phone)
    },
    validateForm (scope) {
      var bus = this
      this.$validator.validateAll(scope).then(function (result) {
        if (result) {
          bus.login()
        } else {
          bus.popup('信息填写有误')
          return false
        }
      })
    },
    login () {
      let form = (this.currentTab.index === '1') ? this.form1 : this.form2
      this.$emit('ready-for-login', [this.currentTab.index, form])
    },
    next () {
      this.$emit('next', this.form1)
    },
    toLastStep () {
      var domain = utils.getQueryString('domain')
      if (utils.getQueryString('h')) {
        window.location.href = window.location.origin + '/#/byl/login?h=' + utils.getQueryString('h') + '&domain=' + domain
      } else {
        this.$router.push({path: '/byl/login'})
      }
    }
  },
  props: ['type']
}
</script>
<style scoped>
  @import '../common/loginNreg/login.css';
</style>



// WEBPACK FOOTER //
// src/components/common/find-pwd/index.vue